module.exports = __webpack_public_path__ + "img/product-placeholder-38.ea5d7ac.png";